import React from 'react';

import { ISO_DATE_FORMAT } from '@gasbi/shared';
import dayjs from 'dayjs';
import { Navigate } from 'react-router-dom';

import { makeAuditRoute } from '@/components/Audit/utils';
import { UserPermissions } from '@/features/permissions';
import { Pages } from '@/pages';

const NominationLayout = React.lazy(() => import('./index'));
const Nominations = React.lazy(() => import('./views/Nominations'));
const MonthlyNominations = React.lazy(
  () => import('./views/MonthlyNominations'),
);
const Renominations = React.lazy(() => import('./views/Renominations'));
const CreatedRenominations = React.lazy(
  () => import('./pages/CreatedRenominations'),
);
const ChangeTriggers = React.lazy(() => import('./pages/ChangeTriggers'));
const PendingRenomination = React.lazy(
  () => import('./pages/PendingRenomination'),
);
const NominationAudit = React.lazy(() => import('@/pages/NominationAudit'));
const RenominationAudit = React.lazy(() => import('@/pages/RenominationAudit'));

const nominationsRoute = [
  {
    path: Pages.NOMINATIONS,
    element: (
      <Navigate
        to={`./${dayjs().format(ISO_DATE_FORMAT)}`}
        relative='path'
        replace
      />
    ),
  },
  {
    path: Pages.MONTHLY_NOMINATIONS,
    element: (
      <Navigate
        to={`./${dayjs().format(ISO_DATE_FORMAT)}`}
        relative='path'
        replace
      />
    ),
  },
  {
    path: Pages.RENOMINATIONS,
    element: (
      <Navigate
        to={`./${dayjs().format(ISO_DATE_FORMAT)}`}
        relative='path'
        replace
      />
    ),
  },
  {
    element: <NominationLayout />,
    children: [
      {
        path: `${Pages.NOMINATIONS}/:date`,
        element: <Nominations />,
      },
      {
        path: `${Pages.MONTHLY_NOMINATIONS}/:date`,
        element: <MonthlyNominations />,
      },
      {
        path: `${Pages.RENOMINATIONS}/:date`,
        element: <Renominations />,
      },
    ],
  },
  {
    path: `${Pages.RENOMINATIONS}/:date/${Pages.CREATED_RENOMINATIONS_PART}`,
    element: <CreatedRenominations />,
  },
  {
    path: `${Pages.RENOMINATIONS}/:date/${Pages.CREATED_RENOMINATIONS_PART}/:renominationId`,
    element: <ChangeTriggers />,
  },
  {
    path: `${Pages.RENOMINATIONS}/:date/${Pages.PENDING_RENOMINATION_PART}`,
    element: <PendingRenomination />,
  },
  makeAuditRoute(
    `${Pages.NOMINATIONS}/:date`,
    <NominationAudit />,
    UserPermissions.ConsumptionAccountingNominationRead,
  ),
  makeAuditRoute(
    `${Pages.RENOMINATIONS}/:date`,
    <RenominationAudit />,
    UserPermissions.ConsumptionAccountingNominationRead,
  ),
];

export default nominationsRoute;
